import React from 'react';
import NavTagline from '../../../nav-tagline/nav-tagline';
import Footer from '../../../shared/Footer';
import { usePortalAuthentication } from '../../../../services/authorizationService';

const SuccessPreRegistration = () => {
    const { logout } = usePortalAuthentication();

    return (
        <div className="SuccessPreRegistration">
            <NavTagline />
            <main className="layout-container">
                <div className="container ctr">
                    <div className="bi-success-check">
                        <i className="bi bi-check2-circle" aria-hidden="true"></i>
                        <span className="sr-only">Success</span>
                    </div>
                    <div className="lg-msg">
                        Registration is complete.
                    </div>
                    <div className="text-size6 spacer-margin3">
                        You are now authorized to access the portal.
                    </div>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            logout();
                        }}
                        className="btn btn-primary"
                        aria-labelledby="Continue to Login">
                        Continue
                    </button>
                </div>
            </main>
            <Footer />
        </div>
    )
};


export default SuccessPreRegistration;
